// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowUpLeftAndArrowDownRight16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-up-left-and-arrow-down-right': IconArrowUpLeftAndArrowDownRight;
    }
}

/**
 * The icon component for the 'arrowUpLeftAndArrowDownRight' icon
 */
export class IconArrowUpLeftAndArrowDownRight extends Icon {
    public constructor() {
        super(arrowUpLeftAndArrowDownRight16X16);
    }
}

registerIcon('icon-arrow-up-left-and-arrow-down-right', IconArrowUpLeftAndArrowDownRight);
export const iconArrowUpLeftAndArrowDownRightTag = 'nimble-icon-arrow-up-left-and-arrow-down-right';
